import { VideoInfoRawData } from "../../../../model/video/VideoInfo.js";
import { MediaControlOrigin } from "../../../events/PlayerEvent.js";
import { GenericFormatLabel, ParsedFormat } from "../FormatAndSizePreference.js";
import { MediaEventName, VideoResource, MediaResourceStats } from "../../MediaResource.js";
import { NativeVODPlayer } from "./NativeVODPlayer.js";


export class NativeVODPlayerMediaResource extends VideoResource<NativeVODPlayer> {


    constructor(
        player: NativeVODPlayer,
        video: HTMLVideoElement,
        listItem: HTMLElement,
        info: VideoInfoRawData,
        fixedDuration: number,
        stats: MediaResourceStats,
        qualities: ParsedFormat[]
    ) {
        super(player, video, listItem, info, fixedDuration, stats, qualities);
    }
    loop(loopEnabled?: boolean): boolean {
        if (!(typeof loopEnabled == "undefined")) {
            this.element.loop = loopEnabled;
        }
        return this.element.loop;
    }



    ensureResourceLoad(): Promise<void> {
        return this.player.load();
    }


    destroy(): void {
        this.element.pause();
        this.player.dispose();
        this.element.currentTime = 0;

    }

    get currentTime(): number {
        if (this.player.hasBeenLoaded()) {
            return this.element.currentTime;
        }
        else return 0;
    }
    get internalDuration(): number {
        if (this.player.hasBeenLoaded()) {
            return this.element.duration;
        }
        else return 0;
    }


    get ended(): boolean {
        if (this.player.hasBeenLoaded()) {
            return this.element.ended;
        }
        else return false;
    }

    get isPaused(): boolean {
        if (this.player.hasBeenLoaded()) {
            return this.element.paused;
        }
        else return true;
    }
    volume(volume?: number): number {
        if (!(typeof volume == "undefined")) {
            if (volume == 0) {
                this.muted(true);
            }
            this.element.volume = volume;

        }
        return this.element.volume;
    }
    muted(muted?: boolean): boolean {
        if (!(typeof muted == "undefined")) {
            this.element.muted = muted;
        }
        return this.element.muted;
    }
    autoplay(autoplay?: boolean): boolean {
        if (!(typeof autoplay == "undefined")) {
            this.element.autoplay = autoplay;
        }
        return this.element.autoplay;
    }
    protected internalPlay(): Promise<any> {
        return this.player.play();
    }

    protected internalRestartOperations(): Promise<any> {
        this.element.currentTime = 0
        return this.play(MediaControlOrigin.USER)
    }

    protected internalResetOperations(): Promise<any> {
        this.element.currentTime = 0
        return this.pause(MediaControlOrigin.USER)
    }

    protected internalPause(): Promise<any> {
        return Promise.resolve(this.element.pause());
    }
    show(): void {
        this.element.style.display = "block";
        this.element.playsInline = true;
        this.element.setAttribute("webkit-playsinline", "");
    }
    hide(): void {
        this.element.style.display = "none";
        this.element.playsInline = false;
        this.element.removeAttribute("webkit-playsinline");
    }

    on(eventName: MediaEventName, listener: EventListenerOrEventListenerObject): void {
        this.element.addEventListener(eventName, listener);
    }
    off(eventName: MediaEventName, listener: EventListenerOrEventListenerObject): void {
        this.element.removeEventListener(eventName, listener);
    }


    beforeUnload(): Promise<void> {
        this.element.pause();
        return Promise.resolve();
    }


    switchQuality(formatLabel: GenericFormatLabel): Promise<ParsedFormat> {
        let rProm: Promise<ParsedFormat> = Promise.resolve(null);
        const avq = this.getAvailableQualities();
        if (avq) {
            const found = avq.find(e => e.label == formatLabel);
            if (found) {
                rProm = this.player.updateFormat(found).then(_ => this.element.play()).then(_ => found)
            }
        }

        return rProm;
    }

    reloadSource(keepCurrentTime: boolean): Promise<void> {
        return this.player.reloadSource(keepCurrentTime);
    }

    seek(time: number): Promise<any> {
        this.element.currentTime = time;
        return Promise.resolve();
    }

    getCurrentFormat(): ParsedFormat {
        return this.player.getCurrentFormat();
    }


}
